import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retryWhen, delay, take, filter, switchMap } from 'rxjs/operators';
import { NetworkStatusService } from './network-status.service';

@Injectable()
export class NetworkAwareInterceptor implements HttpInterceptor {
  constructor(private networkStatusService: NetworkStatusService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Don't retry authentication/login requests - let component handle them immediately
        // Auth errors need immediate feedback to the user without delays from retry logic
        if (request.url?.includes('/login') || request.url?.includes('/auth/')) {
          return throwError(error);
        }

        // Only handle network errors (status 0)
        if (error.status === 0) {
          return this.handleNetworkError(request, next, error);
        }

        // For other errors, just re-throw
        return throwError(error);
      }),
    );
  }

  private handleNetworkError(
    request: HttpRequest<unknown>,
    next: HttpHandler,
    error: HttpErrorResponse,
  ): Observable<HttpEvent<unknown>> {
    // Check if we're currently online
    if (!this.networkStatusService.isCurrentlyOnline()) {
      return throwError(error);
    }

    // For network errors, implement smart retry logic
    return timer(1000).pipe(
      switchMap(() => next.handle(request)),
      retryWhen((errors) =>
        errors.pipe(
          filter((err) => err.status === 0), // Only retry network errors
          delay(2000), // Wait 2 seconds between retries
          take(2), // Max 2 retries
        ),
      ),
      catchError((retryError: HttpErrorResponse) => {
        if (retryError.status === 0) {
        }
        return throwError(retryError);
      }),
    );
  }
}
